<ion-content class="ion-padding">
  <div class="max-page-width">
    <ion-item lines="none" mode="ios" class="title-with-back-button" style="margin-bottom: 5px" >
      <ion-button fill="clear" mode="ios" color="primary"
        (click)="goBack()" >
        <ion-icon class="bp-arrow-left" ></ion-icon>
      </ion-button>
      <ion-label class="ion-text-center ion-text-wrap">
        {{ 'users.userVisibility' | translate | uppercase }}
      </ion-label>
    </ion-item>

    <div class="filter" >
      <ion-searchbar mode="ios" #userSearchSame
        class="section-search-custom"
        [placeholder]="'generic.searchByName' | translate"
        (keyup)="updateSearch($event.target.value)"
      ></ion-searchbar>

      <p (click)="goToAddUser()" >
        +
      </p>
    </div>
    <ion-grid>
      <ion-row class="header-row">
        <ion-col size="5"></ion-col>
        <ion-col size="3">Regras por atributo</ion-col>
        <ion-col size="3">Regra individuais</ion-col>
        <ion-col size="1"></ion-col>
      </ion-row>
      <ion-row *ngFor="let user of users" >
        <ion-col size="5" >
          <img [src]="getImageUrl(user.imageUrl)" default="" />
          {{ user.name }}
        </ion-col>
        <ion-col size="3" >
          {{ user.totalAttributeRules }} regras
        </ion-col>
        <ion-col size="3" >
          {{ user.totalUserRules }} pessoas
        </ion-col>
        <ion-col size="1" >
          <ion-icon class="bp-edit" 
            (click)="manageUserVisibility(user)"
          ></ion-icon>
        </ion-col>
      </ion-row>
    </ion-grid>

    <app-ionic-pagination
      [setPagination]="{
        'itemsCount': usersCount,
        'pageSize': 10
      }"
      (goToPage)="goToPage($event)"
    ></app-ionic-pagination>
  </div>
</ion-content>
